module.exports = __webpack_public_path__ + "static/media/unchecked.257945d6.svg";